import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Container, Card, Button, InputGroup, Form } from "react-bootstrap";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const Fee_Receipt_Finance_Posting = () => {

  const today = new Date().toISOString().split("T")[0]

  const [ddlSection, setDdlSection] = useState([]);
  const [sectionId, setSectionId] = useState("");
  const [paymentMode, setPaymentMode] = useState("ALL");
  const [isProceed, setIsProceed] = useState(false);
  const [isPosting, setIsPosting] = useState(false);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [receiptRows, setReceiptRows] = useState([]);


  useEffect(() => {

    const fetchLists = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/ddl_sections`);
        setDdlSection(response.data);
      } catch (error) {
        console.error("Section DDL Error:", error);
      }
    };
    fetchLists();
  }, []);

  
  // PROCEED
  const handleProceed = async () => {

    if (!sectionId) {
      toast.error("Please select Section.");
      return;
    }

    if (!paymentMode) {
      toast.error("Please select Payment Mode.");
      return;
    }

    if (!fromDate || !toDate) {
      toast.error("Please select From Date and To Date.");
      return;
    }

    if (fromDate > toDate) {
      toast.error("From Date cannot be greater than To Date.");
      return;
    }

    try {
      setIsProceed(false);

      const response = await axios.get( `${BASE_URL}/api/get_receipts_fin_posting`,
        {
          params: {
            section_id: sectionId,
            from_date: fromDate,
            to_date: toDate,
            payment_mode: paymentMode
          }
        }
      );

      if (!response.data || response.data.length === 0) {
        setReceiptRows([]);
        toast.error("No Fee Receipt pending/available for the selected input.");
        return;
      }

      setReceiptRows(response.data);
      setIsProceed(true);

    } catch (error) {
      console.error("Fetch Fee Receipt Error:", error);
    }
  };

  // POST
  const handlePost = async () => {

    if (!sectionId || !paymentMode || !fromDate || !toDate) {
      toast.error("Please select Section, Payment Mode and Date Range.");
      return;
    }

    if (!isProceed) {
      toast.error("Please click Proceed first.");
      return;
    }

    const confirmed = window.confirm(
      `Post the Fee Receipts into Finance`
    );

    if (!confirmed) return;

    try {
      setIsPosting(true);

      const response = await axios.post(
        `${BASE_URL}/api/post_fee_receipts_finance`,
        {
          section_id: sectionId,
          from_date: fromDate,
          to_date: toDate,
          payment_mode: paymentMode
        }
      );
      if (response.data.message === "1") {
        toast.success("Fee Receipts posted in Finance successfully.");
        setReceiptRows([]);
        setIsProceed(false);
      } else {
        toast.error("No Fee Receipts posted.");
      }
    }
     catch (error) {
      console.error("Finance Posting Error:", error);
      toast.error( error.response?.data?.error || "Error while posting fee receipts." );
    } 
    finally {
      setIsPosting(false);
    }
  };

  // CLEAR
  const handleClear = () => {

    const confirmed = window.confirm("Do you want to clear all data?");

    if (!confirmed) return;

    setSectionId("");
    setPaymentMode("ALL");
    setFromDate(today);
    setToDate(today);
    setIsProceed(false);
    setReceiptRows([]);
  };

  const formatAmount = (amount) =>

    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });


  return (

    <Container fluid className="p-3">
      <Card className="p-3 mb-3">
        <Card.Body>

          <Row className="mb-3">

            {/* SECTION */}
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>
                  Section
                </InputGroup.Text>

                <Form.Select
                  value={sectionId}
                  onChange={(e) => {
                    setSectionId(e.target.value);
                    setIsProceed(false);
                    setReceiptRows([]);
                  }}
                >
                  <option value="">-- Select Section --</option>

                  {ddlSection.map((section) => (
                    <option
                      key={section.section_id}
                      value={section.section_id}
                    >
                      {section.section_desc}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Col>

            {/* PAYMENT MODE */}
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>
                  Payment Mode
                </InputGroup.Text>

                <Form.Select
                  value={paymentMode}
                  onChange={(e) => {
                    setPaymentMode(e.target.value);
                    setIsProceed(false);
                    setReceiptRows([]);
                  }}
                >
                  <option value="ALL">All Payment Modes</option>
                  <option value="CASH">Cash</option>
                  <option value="CHQ">Cheque/DD</option>
                  <option value="NEFT">NEFT/IMPS</option>
                  <option value="OL">Online</option>
                </Form.Select>
              </InputGroup>
            </Col>
          </Row>

          {/* BUTTONS */}
          <Row>

            {/* FROM RECEIPT DATE */}
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>
                  From Rcpt Date
                </InputGroup.Text>

                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    setIsProceed(false);
                    setReceiptRows([]);
                  }}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>
                  To Rcpt Date
                </InputGroup.Text>

                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                    setIsProceed(false);
                    setReceiptRows([]);
                  }}
                />
              </InputGroup>
            </Col>

            {/* <Col md={2}></Col> */}

            <Col md={4}>
              <div className="d-flex gap-2 justify-content-end">

                <Button
                  variant="primary"
                  onClick={handleProceed}
                  style={{ width: "140px" }}>Check Reciept
                </Button>

                <Button
                  variant="success"
                  onClick={handlePost}
                  disabled={!isProceed || isPosting}
                  style={{ width: "120px"}} >
                  {isPosting ? "Posting..." : "Post"}
                </Button>

                <Button
                  variant="secondary"
                  onClick={handleClear}
                  style={{ width: "120px"}} > Clear </Button>

              </div>


            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Receipt Child Table */}
      <Card className="p-3">
        {/* Receipt Child Table */}
        <div className="responsive-table-reports-wrapper">
          <table
            style={{ minWidth: "900px", maxHeight: "35px" }} className="responsive-table scty-custom-table" >
            <thead className="table-light">
              <tr>
                <th style={{ width: "80px" }}>Sr. No.</th>
                <th>GR No.</th>
                <th>Receipt No.</th>
                <th>Receipt Date</th>
                <th>Payment Mode</th>
                <th style={{textAlign: "right"}}>Amount</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {receiptRows.length > 0 ? (
                receiptRows.map((row, index) => (
                  <tr key={row.fee_rcpt_no}>
                    <td>{index + 1}</td>
                    <td>{row.gr_no}</td>
                    <td>{row.fee_rcpt_no}</td>
                    <td>{row.fee_rcpt_date}</td>
                    <td>{row.payment_mode}</td>
                    <td style={{textAlign: "right"}}>{formatAmount(row.finance_amount)}</td>
                    <td>{row.status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        </Card>
    </Container>

  );
};

export default Fee_Receipt_Finance_Posting;
